module.exports = __webpack_public_path__ + "static/img/n_1.1a55c33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/n_1.jpg
// module id = JKD/
// module chunks = 6